import React, { useEffect, useState } from 'react'


// third party
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet'

//component
import PageUrlGuid from '../component/pageUrlGuid';

//services
import Seperator from '../component/seperator';

const ContactUs = () => {

    return (
        <>
        <>
                    <Helmet>
                <title>نیو وبینار |  تماس با ما </title>
            </Helmet>
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                   ارتباط با ما
                </h1>
            </PageUrlGuid>
            <div className='contact-us'>
                <div className='contact-way'>
                    <div> 
                        <i className='fas fa-bullhorn'></i>
                        <span>راه های ارتباطی جهت پشتیبانی دوره ها در تلگرام , روبیکا , ایتا و سروش :</span>
                    </div>
                    <div className='channel'>
                        new_webinar@
                    </div>
                </div>
                <div className='ad-way'>
                    <div> 
                        <i className='fas fa-phone'></i>
                        <span>راه های ارتباطی جهت هماهنگی و رزرو تبلیغات :</span>
                    </div>
                    <div className='phone'>
                        09360682597
                    </div>
                </div>
            </div>
        </>
        </>

    )
}


export default ContactUs